<obg-regulatory-bar desktopView [aamsGameData]="aamsGameData"></obg-regulatory-bar>

<mat-toolbar color="primary" role="banner" *ngIf="!regulatoryBarOnly">
	<mat-toolbar-row class="obg-m-header-toolbar-main">
		<div class="obg-m-header-logo-container">
			<a
				class="obg-m-header-logo"
				test-id="header-logo"
				data-test-id="header-logo"
				[obgInteraction]="logoTrackingData"
				[obgRouteLink]="homeRoute"
			>
				<img [obgImageContent]="brandLogo$ | async" />
			</a>
			<obg-m-beta-badge-container></obg-m-beta-badge-container>
		</div>
		<obg-regulatory-items></obg-regulatory-items>
		<div
			class="obg-m-header-user-menu"
			[ngClass]="{ 'has-login': isLoginEnabled && !isAuthenticated }"
			*ngIf="!toolbarHidden"
		>
			<a class="sitemap-sportsbook" [href]="sbSitemapRoute$ | async" *ngIf="showSportsbookSitemap"
				>Sportsbook Sitemap</a
			>
			<obg-m-ticket-counter *ngIf="isAuthenticated && showTicketCounter"></obg-m-ticket-counter>
			<obg-m-language-selector-container
				*ngIf="showLanguageSelector$ | async"
			></obg-m-language-selector-container>
			<a
				mat-mini-fab
				trigger
				obgCustomerSupportLink
				matTooltip="{{'general.help' | translate}}"
				matTooltipClass="obg-m-navigation-tooltip"
				test-id="header-help-icon"
				[obgInteraction]="helpTrackingData"
			>
				<span class="ico-help-bubble"></span>
			</a>
			<obg-app-m-account-control-container [balanceHidden]="balanceHidden"></obg-app-m-account-control-container>
		</div>
		<span class="obg-m-header-toolbar-main-title" *ngIf="titleText">{{ titleText | translate }}</span>
	</mat-toolbar-row>
	<mat-toolbar-row *ngIf="!navigationHidden" class="obg-m-header-toolbar-navigation">
		<nav *ngIf="navigationBarData$ | async as data" test-id="product-navigation">
			<obg-menu
				hideIcons
				[menuItems]="data.productMenu"
				[routeLinkActiveOptions]="linkActiveOptions"
				(selectedItem)="menuItemSelected($event.item)"
			>
			</obg-menu>
			<div class="search-bar" *ngIf="isSearchOnHomePageEnabled$ | async">
				<button
					mat-flat-button
					class="obg-m-game-search-button-container"
					(click)="openSearch()"
					[obgInteraction]="searchTrackingData"
					test-id="game-search-button"
					color="secondary"
				>
					<span class="ico-search"></span>
					<span class="button-text">{{ searchPlaceholder | translate }}</span>
				</button>
			</div>
			<obg-icon-list
				*ngIf="showSponsorshipIconList && data.icons.length > 0"
				[icons]="data.icons"
			></obg-icon-list>
		</nav>
	</mat-toolbar-row>
</mat-toolbar>

<obg-m-annual-validation-notification
	test-id="customer-validation-notification"
	data-test-id="customer-validation-notification"
	[expired]="actionExpired"
	[processing]="isDocumentProcessing"
	[annualValidation]="isAnnualValidationNotificationEnabled"
	[documentValidation]="isDocumentValidationEnabled"
	[socialBenefits]="isSocialBenefitsRestrictionEnabled"
	[desktop]="true"
	(dismissNotification)="dismissNotification()"
	*ngIf="showValidationNotification$ | async"
></obg-m-annual-validation-notification>

<obg-m-kyc-notification
	test-id="kyc-notification"
	*ngIf="showKycNotification"
	[notificationData]="notificationData"
	is18Plus
	[style.height.px]="kycHeaderHeight"
	(close)="hideKyc()"
></obg-m-kyc-notification>
<obg-m-iaui-notification *ngIf="showIauiNotification"></obg-m-iaui-notification>
